export default __webpack_public_path__ + "static/media/hexagon-off.dea0eac9.svg";